import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=860b7670&scoped=true"
import script from "./EditCampaign.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCampaign.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=860b7670&prod&lang=scss&scoped=true"
import style1 from "./EditCampaign.vue?vue&type=style&index=1&id=860b7670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860b7670",
  null
  
)

export default component.exports